import { mutationTypes, getterTypes, actionTypes } from '../../../types';
export default store => {
	store.subscribe((mutation, state) => {
		if (state.nearestBeaconAlgorithm.config.isActive && mutation.type === mutationTypes.bluetoothScanStep) {
			// clone detected Beacons to prevent side effects
			store.dispatch(actionTypes.nearestBeaconStep, {
				detectedBeacons: JSON.parse(JSON.stringify(state.bluetooth.detectedBeacons)),
			});
		} else if (mutation.type === mutationTypes.setDatasource) {
			const config = Object.assign({}, store.getters[getterTypes.globalConfig].nearestBeaconAlgParameters);
			store.commit(mutationTypes.nearestBeaconSetConfig, config);
		} else if (mutation.type === mutationTypes.setExhibitionID) {
			// TODO Exhibition specifig updating
		} else if (mutationTypes.nearestBeaconWinnerOfTypeTrigger === mutation.type) {
			const beaconLocation =
				state.nearestBeaconAlgorithm.winnerOfTypeTrigger.type === 'extender'
					? store.getters[getterTypes.currentExhibition].beaconMap[
							state.nearestBeaconAlgorithm.winnerOfTypeTrigger.extendedURL
					  ]
					: store.getters[getterTypes.currentExhibition].beaconMap[
							state.nearestBeaconAlgorithm.winnerOfTypeTrigger.url
					  ];

			if (beaconLocation && beaconLocation.triggerType === 'forceTrigger') {
				store.dispatch(actionTypes.setArticle, {
					articleID: beaconLocation.articleID,
				});
			}
		}
	});
};
